/**
 * useEliasEdition — single source of truth for "are we on the Elias
 * edition right now?"
 *
 * Mirrors apps/web/src/ministry/hooks/useMinistryEdition.ts. Synchronous
 * detection (path > query > localStorage), wrapped in useMemo so every
 * component below the shell can ask the same question without re-parsing
 * window.location on every render.
 */

import { useMemo } from "react";
import { detectEdition } from "@/ministry/lib/edition-detection";

export function useEliasEdition() {
  return useMemo(() => detectEdition(), []);
}

export function useIsEliasEdition(): boolean {
  return useEliasEdition().edition === "individual-elias";
}
